export default __webpack_public_path__ + "static/media/Endless Battle Blade.f06981dc.jpg";